var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { Container, MilestonesContainer, MilestonesWrapper, Points, PointsCard, PointsTitle, Title } from './subcomponents';
import isTjx from '../../../../../helpers/isTjx';
/*
 * variable that serves as a reference to validate if the milestone
 * to be rendered is the middle element, because it is necessary to add
 * specific CSS styles to it
 */
var MIDDLE_MILESTONE = 1;
// Array used to filter and sort the milestones data displayed in the UI
var milestonesIds = ['earnedYTD', 'redeemedYTD'];
var milestonesTranslationsKeys = {
    redeemedYTD: 'totalPointsRedeemedYTD',
    earnedYTD: 'totalPointsEarnedYTD',
    redeemedYearToDate: 'totalPointsSavedYTD'
};
var Milestones = function (_a) {
    var _b = _a.rewardsDetails, rewardsDetails = _b === void 0 ? [] : _b, _c = _a.redeemedYearToDate, redeemedYearToDate = _c === void 0 ? '0' : _c, clientId = _a.clientId;
    var t = useTranslation().t;
    var rewardsDetailsMilestones = rewardsDetails
        .filter(function (rewardsDetail) { return milestonesIds.includes(rewardsDetail.Id); })
        .sort(function (a, b) { return milestonesIds.indexOf(a.Id) - milestonesIds.indexOf(b.Id); });
    // This missing data comes from another endpoint
    var certificateData = {
        Id: 'redeemedYearToDate',
        value: redeemedYearToDate
    };
    var data = __spreadArray(__spreadArray([], rewardsDetailsMilestones, true), [certificateData], false).map(function (item) { return ({
        id: item.Id,
        value: item.Id === 'redeemedYearToDate'
            ? Number(item.value).toLocaleString('en-US', {
                style: 'currency',
                currency: 'USD'
            })
            : Number(item.value).toLocaleString(),
        displayName: t("fullDetailsPage.".concat(clientId, ".").concat(milestonesTranslationsKeys[item.Id]))
    }); });
    var rewardsMilestones = isTjx(clientId)
        ? 'myRewardsMilestones'
        : 'yourRewardsMilestones';
    return (_jsxs(Container, { children: [_jsx(Title, __assign({ "data-cy": "milestone-header" }, { children: t("fullDetailsPage.".concat(rewardsMilestones)) })), _jsx(MilestonesWrapper, { children: _jsx(MilestonesContainer, { children: data.map(function (element, index) { return (_jsxs(PointsCard, __assign({ "$borders": index === MIDDLE_MILESTONE }, { children: [_jsx(Points, __assign({ "data-cy": "milestone-points-".concat(element.displayName) }, { children: element.value })), _jsx(PointsTitle, __assign({ "data-cy": "milestone-title-".concat(element.displayName) }, { children: element.displayName }))] }), element.id)); }) }) })] }));
};
export default Milestones;
